module.exports = __webpack_public_path__ + "recreation.svg?d27c22246502edb594f5c20d405a86bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/recreation.svg
// module id = 109
// module chunks = 0